import { getSessionTheme } from "../../helper/session";

export const defaultSettings = {
    themeMode: getSessionTheme(),
    themeContrast: 'bold',
    themeLayout: 'vertical',
    themeColorPresets: 'default',
    themeStretch: true,
};
